import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { LoginService } from 'src/app/services/login/login.service';
import { ShopServiceService } from 'src/app/services/shop-service.service';

@Component({
  selector: 'app-store-change',
  templateUrl: './store-change.page.html',
  styleUrls: ['./store-change.page.scss'],
})
export class StoreChangePage implements OnInit {
  userID;

  ownerForm: FormGroup;
  storeForm: FormGroup;
  addressForm: FormGroup;

  ownerDetails;
  storeDetails;
  addressDetails;

  constructor(
    private menu: MenuController,
    private router: Router,
    private auth: AngularFireAuth,
    private formBuilder: FormBuilder,
    private shopService: ShopServiceService,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.auth.authState.subscribe((user) => {
      if (user) {
        this.userID = user.uid;
        this.getOwnerDetails();
        this.getStoreDetails();
      }
    });
  }

  getOwnerDetails() {
    this.shopService.getOwnerDetails(this.userID).subscribe((res: any) => {
      const data = res.data();
      const { name, surname, phone, email } = data;

      this.ownerForm = this.formBuilder.group({
        name: [name, [Validators.required, Validators.pattern('^[a-zA-Z]+$')]],
        surname: [
          surname,
          [Validators.required, Validators.pattern('^[a-zA-Z]+$')],
        ],
        phone: [
          phone,
          [Validators.required, Validators.pattern('^0[0-9]{9}$')],
        ],
        email: [
          email,
          [
            Validators.required,
            Validators.pattern(
              '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
            ),
          ],
        ],
      });
    });
  }

  getStoreDetails() {
    this.shopService.getShopProfile(this.userID).subscribe((res: any) => {
      if (res.exists) {
        const data = res.data();
        const { storeName, contactNo, email, description } = data;
        this.storeForm = this.formBuilder.group({
          storeName: [storeName, [Validators.required]],
          contactNo: [
            contactNo,
            [Validators.required, Validators.pattern('^0[0-9]{9}$')],
          ],
          // email: [email, [Validators.required]],
          // description: [description, [Validators.required]],
        });
      } else {
        this.storeForm = this.formBuilder.group({
          storeName: ['', [Validators.required]],
          contactNo: [
            '',
            [Validators.required, Validators.pattern('^0[0-9]{9}$')],
          ],
          // email: ['', [Validators.required]],
          // description: ['', [Validators.required]],
        });
      }
    });
  }

  getAddress() {}

  updateOwnerDetails() {
    const details = this.ownerForm.value;
    console.log(details);
  }

  updateStoreDetails() {
    const details = this.storeForm.value;
    this.shopService
      .updateShopProfile(this.userID, details)
      .then(() => {
        alert('Store Profile updated');
      })
      .catch((e) => {
        console.log(e);
        alert('Error updating Store Profile');
      });
  }

  updateAddress() {
    this.router.navigate(['/location'], {
      queryParams: { from: this.router.url },
    });
  }

  openStore(menu) {
    this.menu.enable(true, 'dash' + menu);
    this.menu.open('dash' + menu);
  }

  storeHome() {
    this.router.navigate(['store-home']);
  }
  orders() {
    this.router.navigate(['store-orders']);
  }
  history() {
    this.router.navigate(['store-history']);
  }
  products() {
    this.router.navigate(['store-view']);
  }

  edit() {
    this.router.navigate(['store-change']);
  }

  logout() {
    this.loginService.logout();
  }
}
